// @flow
import * as React from 'react';
import last from 'lodash/last';
import styles from './styles';

type Props = {
  image: Object,
  preferredSize: number,
  height: number,
  width: number,
};

export default function ImageSnippetModal({ image, preferredSize, height, width }: Props) {
  function getBiggerImageKeyByPreferredSize() {
    const preferredAndLowerSizesKeys = Object.keys(image).filter(
      key => parseInt(key, 10) <= preferredSize
    );

    return last(preferredAndLowerSizesKeys);
  }

  const imageKey = getBiggerImageKeyByPreferredSize();
  const imageSrc = image[imageKey];

  return (
    <React.Fragment>
      <img
        src={imageSrc}
        className="image-snippet-modal"
        itemProp="image"
        height={height}
        width={width}
      />
      <style jsx>{styles}</style>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./app/common/ImageSnippetModal/index.js